import React from 'react'
import ESealingApiContent from '../components/ESealingApi/ESealingApiContent'

const ESealingApi = (props) => {

  

  return (
    <>
        <ESealingApiContent following = {props.following === true ? true : false}/>
    </>
  )
}

export default ESealingApi